var map = {
	"./ja/01_tag_free-wifi.svg": 358,
	"./ja/02_tag_free-parking.svg": 359,
	"./ja/03_tag_paid-parking.svg": 360,
	"./ja/04_tag_indoor-pool.svg": 361,
	"./ja/05_tag_outdoor-pool-in-summer.svg": 362,
	"./ja/06_tag_beach.svg": 363,
	"./ja/07_tag_large-public-bath.svg": 364,
	"./ja/08_tag_hot-spring.svg": 365,
	"./ja/09_tag_spa.svg": 366,
	"./ja/10_tag_outdoor-bath.svg": 367,
	"./ja/11_tag_non-smoking.svg": 368,
	"./ja/12_tag_convenience-store.svg": 369,
	"./ja/13_tag_restaurant.svg": 370,
	"./ja/14_tag_connecting-room.svg": 371,
	"./ja/15_tag_with-kitchen.svg": 372,
	"./ja/16_tag_kitchen.svg": 373,
	"./ja/17_tag_fitness-gym.svg": 374,
	"./ja/18_tag_paid-massage-service.svg": 375,
	"./ja/19_tag_paid-beauty-salon.svg": 376,
	"./ja/20_tag_vending-machine.svg": 377,
	"./ja/21_tag_kitchenware-tableware.svg": 378,
	"./ja/22_tag_washing-machine.svg": 379,
	"./ja/23_tag_clothes-dryer.svg": 380,
	"./ja/24_tag_paid-coin-laundry.svg": 381,
	"./ja/25_tag_courtesy-bus.svg": 382,
	"./ja/26_tag_lounge.svg": 383,
	"./ja/27_tag_bbq-garden.svg": 384,
	"./ja/28_tag_induction-cooker.svg": 229,
	"./ja/29__tag_microwave.svg": 231,
	"./ja/30_tag_smoking-area.svg": 385,
	"./ja/31_tag_pet-friendly.svg": 386,
	"./ja/tag_convenience-store.svg": 387,
	"./ja/tag_free-parking.svg": 388,
	"./ja/tag_free-wifi.svg": 389,
	"./ja/tag_outdoor-pool-in-summer.svg": 390,
	"./ja/tag_paid-coin-laundry.svg": 391,
	"./ja/tag_restaurant.svg": 392,
	"./ja/tag_vending-machine.svg": 393,
	"./tw/01_tag_free-wifi.svg": 394,
	"./tw/02_tag_free-parking.svg": 395,
	"./tw/03_tag_paid-parking.svg": 396,
	"./tw/04_tag_indoor-pool.svg": 397,
	"./tw/05_tag_outdoor-pool-in-summer.svg": 398,
	"./tw/06_tag_beach.svg": 399,
	"./tw/07_tag_large-public-bath.svg": 400,
	"./tw/08_tag_hot-spring.svg": 401,
	"./tw/09_tag_spa.svg": 402,
	"./tw/10_tag_outdoor-bath.svg": 403,
	"./tw/11_tag_non-smoking.svg": 404,
	"./tw/12_tag_convenience-store.svg": 405,
	"./tw/13_tag_restaurant.svg": 406,
	"./tw/14_tag_connecting-room.svg": 407,
	"./tw/15_tag_with-kitchen.svg": 408,
	"./tw/16_tag_kitchen.svg": 409,
	"./tw/17_tag_fitness-gym.svg": 410,
	"./tw/18_tag_paid-massage-service.svg": 411,
	"./tw/19_tag_paid-beauty-salon.svg": 412,
	"./tw/20_tag_vending-machine.svg": 413,
	"./tw/21_tag_kitchenware-tableware.svg": 414,
	"./tw/22_tag_washing-machine.svg": 415,
	"./tw/23_tag_clothes-dryer.svg": 416,
	"./tw/24_tag_paid-coin-laundry.svg": 417,
	"./tw/25_tag_courtesy-bus.svg": 418,
	"./tw/26_tag_lounge.svg": 419,
	"./tw/27_tag_bbq-garden.svg": 420,
	"./tw/28_tag_induction-cooker.svg": 230,
	"./tw/29__tag_microwave.svg": 232,
	"./tw/30_tag_smoking-area.svg": 421,
	"./tw/31_tag_pet-friendly.svg": 422,
	"./tw/tag_convenience-store.svg": 423,
	"./tw/tag_free-parking.svg": 424,
	"./tw/tag_free-wifi.svg": 425,
	"./tw/tag_outdoor-pool-in-summer.svg": 426,
	"./tw/tag_paid-coin-laundry.svg": 427,
	"./tw/tag_restaurant.svg": 428,
	"./tw/tag_vending-machine.svg": 429
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 357;